[
  {
    "route": "home",
    "label": "home.label",
    "icon": "glicon-home",
    "action": "home"
  },
  {
    "route": "dashboard",
    "label": "Dashboard",
    "icon": "glicon-dashboard",
    "action": "dashboard.home"
  },
  {
    "route": "clients",
    "label": "clients.label",
    "icon": "glicon-clients",
    "action": "clients.list"
  },
  {
    "route": "groups",
    "label": "groups.label",
    "icon": "glicon-class",
    "action": "groups.list"
  },
  {
    "route": "mars",
    "label": "mars.label",
    "icon": "glicon-play-game",
    "action": "mars.list"
  },
  {
    "route": "students",
    "label": "students.label",
    "icon": "glicon-students",
    "action": "students.list"
  },
  {
    "menu": "training",
    "label": "nouns.campus",
    "icon": "glicon-book",
    "action": "training.menu",
    "navigation_menu": [
      {
        "route": "courses",
        "label": "courses.title",
        "icon": "glicon-courses",
        "action": "training.courses.list"
      },
      {
        "route": "itineraries",
        "label": "itineraries.title",
        "icon": "glicon-itinerary",
        "action": "training.itineraries.list"
      },
      {
        "route": "ranking",
        "label": "ranking.title",
        "icon": "glicon-ranking",
        "action": "training.ranking.detail"
      }
    ]
  },
  {
    "route": "roleplay",
    "label": "roleplay.label",
    "icon": "glicon-gamer",
    "action": "roleplay.list"
  },
  {
    "route": "distributors",
    "label": "distributors.label",
    "icon": "glicon-axis-arrow",
    "action": "distributors.list"
  },
  {
    "route": "orders",
    "label": "orders.label",
    "icon": "glicon-truck",
    "action": "orders.list"
  },
  {
    "route": "resources",
    "label": "resources.label",
    "icon": "glicon-resources",
    "action": "resources.list"
  },
  {
    "route": "agents",
    "label": "agents.label",
    "icon": "glicon-admin",
    "action": "agents.list"
  },
  {
    "route": "demos",
    "label": "demos.label",
    "icon": "glicon-demos",
    "action": "demos.list"
  },
  {
    "route": "games",
    "label": "games.label",
    "icon": "glicon-games",
    "action": "games.list"
  },
  {
    "route": "customizations",
    "label": "customizations.label",
    "icon": "glicon-filing-box",
    "action": "customizations.menu",
    "class": "hide-on-med-and-down"
  },
  {
    "route": "reports",
    "label": "reports.label",
    "icon": "glicon-reports",
    "action": "reports.menu"
  },
  {
    "menu": "settings",
    "label": "nouns.settings",
    "icon": "glicon-settings",
    "action": "settings.menu",
    "class": "push-bottom",
    "navigation_menu": [
      {
        "route": "settings/clients",
        "label": "clients.label",
        "icon": "glicon-clients",
        "action": "settings.clients"
      },
      {
        "route": "mail/scheduled",
        "label": "mail.scheduled.label",
        "icon": "glicon-send",
        "action": "mail.scheduled"
      }
    ]
  },
  {
    "menu": "monitor",
    "label": "monitor.title",
    "icon": "glicon-misc",
    "action": "monitor",
    "navigation_menu": [
      {
        "route": "monitor/redis",
        "label": "monitor.redis",
        "icon": "glicon-misc",
        "action": "monitor.redis"
      },
      {
        "route": "monitor/activity",
        "label": "monitor.activity",
        "icon": "glicon-misc",
        "action": "monitor.activity"
      },
      {
        "route": "monitor/metrics",
        "label": "monitor.metrics",
        "icon": "glicon-misc",
        "action": "monitor.metrics"
      }
    ]
  }
]